var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pro-list"},[_c('div',{staticClass:"pro-title"},[_vm._v("配 送 至")]),_vm._v(" "),_c('div',{staticClass:"pro-content"},[_c('en-region-picker',{staticStyle:{"display":"inline-block"},attrs:{"api":_vm.MixinRegionApi},on:{"changed":_vm.handleShipAreaChange}}),_vm._v(" "),_c('span',{staticClass:"area-tip"},[_vm._v(_vm._s(_vm.stockMsg))])],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4664c302","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/goods/-goods-ship.vue
// module id = null
// module chunks = 